import * as React from 'react';
import { forwardRef } from 'react';
const Riverty = (props, ref) => {
    const prefixId = React.useId();
    return (React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props },
        React.createElement("g", { clipPath: `url(#$${prefixId}__clip0_4460_85)` },
            React.createElement("path", { d: "M30 0H10C4.477 0 0 4.477 0 10v20c0 5.523 4.477 10 10 10h20c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z", fill: "#527A42" }),
            React.createElement("path", { fill: "#fff", d: "M11 15h5v15h-5zM16 10h15v5H16z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: `$${prefixId}__clip0_4460_85` },
                React.createElement("rect", { width: 40, height: 40, rx: 10, fill: "#fff" })))));
};
const ForwardRef = forwardRef(Riverty);
export default ForwardRef;
ForwardRef.displayName = 'Riverty';
//# sourceMappingURL=Riverty.js.map